import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  listItem: {
    padding: theme.spacing(0.5, 0, 0.5, 2),
    margin: theme.spacing(1.5, 0),
    borderRadius: "8px",
  },
  listItemIcon: {
    color: theme.palette.text.primary,
    minWidth: 0,
    marginRight: theme.spacing(2),

    "& .MuiSvgIcon-root": {
      width: "24px",
      height: "24px",
      fill: theme.palette.text.primary,
    },

    "&.selected .MuiSvgIcon-root": {
      fill: theme.palette.primary.contrastText,
    },
  },
  selected: {
    borderRadius: "8px",
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
  },
}));

export default useStyles;
